import { render, staticRenderFns } from "./SceneLibDetail.vue?vue&type=template&id=77533e38&scoped=true"
import script from "./SceneLibDetail.vue?vue&type=script&lang=js"
export * from "./SceneLibDetail.vue?vue&type=script&lang=js"
import style0 from "./SceneLibDetail.vue?vue&type=style&index=0&id=77533e38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77533e38",
  null
  
)

export default component.exports